export default "__VITE_ASSET__C8pGrO5J__"